module.exports = __webpack_public_path__ + "img/10-5.a772c336.jpg";